/**
 * @generated SignedSource<<53c7a4fd353564d4cac2759343e1014f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type usePortalEligibleApproversQuery$variables = {
  projectId: string;
};
export type usePortalEligibleApproversQuery$data = {
  readonly viewer: {
    readonly project: {
      readonly portalEligibleApprovers: ReadonlyArray<{
        readonly portalUserId: string | null;
        readonly email: string | null;
        readonly roleLabel: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type usePortalEligibleApproversQuery = {
  variables: usePortalEligibleApproversQuery$variables;
  response: usePortalEligibleApproversQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PortalEligibleApprover",
  "kind": "LinkedField",
  "name": "portalEligibleApprovers",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roleLabel",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePortalEligibleApproversQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePortalEligibleApproversQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c6570e1ec547ec6f0ebd947aee79503f",
    "id": null,
    "metadata": {},
    "name": "usePortalEligibleApproversQuery",
    "operationKind": "query",
    "text": "query usePortalEligibleApproversQuery(\n  $projectId: String!\n) {\n  viewer {\n    project(id: $projectId) {\n      portalEligibleApprovers {\n        portalUserId\n        email\n        roleLabel\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bec929e475ed3b8783285515a5f5072b";

export default node;
